define([
  'react',
  'react-dom',
  'jsx!launcher/views/listbuilder/wysiwyg/Tab',
], (React, ReactDOM, Tab) => {
  class TabStep {
    constructor(settings) {
      this.settings = settings;
    }

    render(container) {
      // Can't render into undefined or null container.
      if (!container) return;

      ReactDOM.render((
          <Tab
            {...this.settings}
          />
        ),
        container
      );
    }
  }

  return TabStep;
});
